import { Box, BoxProps } from '@chakra-ui/react';

export type SurfaceVariant =
  | 'card'
  | 'panel'
  | 'rail'
  | 'popover'
  | 'muted'
  | 'interactive'
  | 'section'
  | 'inset'
  | 'table'
  | 'metric'
  | 'drawerSection'
  | 'drawerInset'
  | 'drawerRow';

export interface SurfaceProps extends BoxProps {
  variant?: SurfaceVariant;
}

const surfaceLayerByVariant: Record<SurfaceVariant, string> = {
  card: 'surfaceCard',
  panel: 'surfacePanel',
  rail: 'surfaceRail',
  popover: 'surfacePopover',
  muted: 'surfaceMuted',
  interactive: 'surfaceInteractive',
  section: 'surfaceSection',
  inset: 'surfaceInset',
  table: 'dataTableSurface',
  metric: 'metricCard',
  drawerSection: 'drawerSection',
  drawerInset: 'drawerInset',
  drawerRow: 'drawerRow',
};

export function Surface({ variant = 'card', ...props }: SurfaceProps) {
  return <Box layerStyle={surfaceLayerByVariant[variant]} {...props} />;
}
